import React from 'react';
import PropTypes from 'prop-types';
import { CustomTooltip, ScoreTag, Tag, TagsContainer, TagVariants, Themes } from '@cyberint/dsc';
import * as S from './styled';

export const EllipsisCell = ({ renderedCellValue, fallback = '' }) => {
  const cellValue = renderedCellValue ?? fallback;
  const tooltipTitle = typeof cellValue === 'string' || typeof cellValue === 'number' ? String(cellValue) : undefined;

  return (
    <CustomTooltip title={tooltipTitle} mode={Themes.LIGHT} maxWidth="280px">
      <S.EllipsisTooltipWrapper>
        <S.EllipsisText>{cellValue}</S.EllipsisText>
      </S.EllipsisTooltipWrapper>
    </CustomTooltip>
  );
};

EllipsisCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]),
  fallback: PropTypes.node
};

export const ExploitedByTagsCell = ({ renderedCellValue, fallback = '' }) => {
  if (!Array.isArray(renderedCellValue) || !renderedCellValue.length) {
    return <S.EllipsisText>{fallback}</S.EllipsisText>;
  }

  const chips = renderedCellValue.map(threat => <Tag key={threat} content={threat} variant={TagVariants.MAIN} />);

  return <TagsContainer chips={chips} count={1} variant={TagVariants.MAIN} regularTooltip />;
};

ExploitedByTagsCell.propTypes = {
  renderedCellValue: PropTypes.arrayOf(PropTypes.string),
  fallback: PropTypes.node
};

export const ScoreBadgeCell = ({ renderedCellValue, fallback = '' }) =>
  renderedCellValue && renderedCellValue !== '-' ? <ScoreTag value={Number(renderedCellValue)} /> : fallback;

ScoreBadgeCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fallback: PropTypes.node
};

export const CvssBadgeCell = ({ renderedCellValue, fallback = '' }) =>
  renderedCellValue && renderedCellValue !== '-' ? (
    <S.CvssScoreTagWrapper>
      <ScoreTag value={Number(renderedCellValue)} />
    </S.CvssScoreTagWrapper>
  ) : (
    fallback
  );

CvssBadgeCell.propTypes = {
  renderedCellValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fallback: PropTypes.node
};
